module.exports = __webpack_public_path__ + "static/media/compose_topic_2x.f33aa405.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brite/compose_topic_2x.png
// module id = 285
// module chunks = 0